<app-insights-access-banner message="Sign in to Insights to access ESG Insights for this assessment." />

@if (!store.hasNoDisplayableResult()) {
  <mat-expansion-panel #insightsPanel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title> ESG Insights </mat-panel-title>
    </mat-expansion-panel-header>

    @if (store.syncWarning()) {
      <p class="insights-message">{{ store.syncWarning() }}</p>
    }

    @switch (store.view()) {
      @case ('loading') {
        <div class="insights-state">
          <mat-spinner diameter="28"></mat-spinner>
          <p>{{ authPending() ? 'Waiting to be signed in to Insights...' : 'Loading insights...' }}</p>
        </div>
      }
      @case ('generating') {
        <div class="insights-state">
          <mat-spinner diameter="28"></mat-spinner>
          <p>Generating insights...</p>
        </div>
      }
      @case ('completed') {
        <div class="insights-content" [innerHTML]="store.markdown() | markdown"></div>
      }
      @case ('error') {
        <p class="insights-message">Insights generation failed.</p>
      }
      @case ('serviceDown') {
        <p class="insights-message">The insights service is currently unavailable.</p>
      }
      @case ('unauthorized') {
        <p class="insights-message">Insights access is unavailable.</p>
      }
      @case ('accessUnavailable') {
        <p class="insights-message">
          Insight generation is pending, but its status cannot be checked because Insights access is unavailable.
        </p>
      }
    }
  </mat-expansion-panel>
}
